module.exports = __webpack_public_path__ + "img/title_sp.a063428b.svg";